// Zonamento landing illustration (mid-v6k8.16): a buyer's search drawn on the city's
// plan. Lots are coloured by land use like a municipal zoning plan (yellow Habitação,
// red Equipamentos, green Espaços verdes, hatched paper Indústria), each with a 1px ink
// edge (The Inked Edge Rule). On top: the navy dashed commute area and one selected lot
// with its Match pin. The legend names every colour (The Legend Rule). Rendered only
// with the switch on; colours live in landing.css.
const LOTS = [
  // [x, y, w, h, use]
  [8, 8, 72, 56, 'hab'], [88, 8, 72, 56, 'equip'], [168, 8, 72, 56, 'verde'], [248, 8, 64, 56, 'hab'],
  [8, 72, 72, 56, 'verde'], [88, 72, 72, 56, 'hab'], [168, 72, 72, 56, 'hab'], [248, 72, 64, 56, 'ind'],
  [8, 136, 72, 56, 'hab'], [88, 136, 72, 56, 'hab'], [168, 136, 72, 56, 'equip'], [248, 136, 64, 56, 'verde'],
];

const ZONING_LEGEND = [
  ['hab', 'Habitação'],
  ['equip', 'Equipamentos'],
  ['verde', 'Espaços verdes'],
  ['ind', 'Indústria'],
  ['area', '≤ 30 min do trabalho'],
];

function ZoningLegend() {
  return (
    <ul className="zp-legend" aria-label="Legenda">
      {ZONING_LEGEND.map(([key, label]) => (
        <li key={key}><span className={`zp-swatch zp-swatch-${key}`} aria-hidden="true" />{label}</li>
      ))}
    </ul>
  );
}

export default function ZoningPlan() {
  return (
    <figure className="zp" aria-label="Exemplo de uma procura desenhada sobre a planta da cidade: usos do solo, a área a 30 minutos do trabalho e uma casa com 78% de Match">
      <svg className="zp-svg" viewBox="0 0 320 200" role="presentation" aria-hidden="true">
        {/* ponytail: fixed id, the plan renders once per page */}
        <defs>
          <pattern id="zp-hatch" width="7" height="7" patternUnits="userSpaceOnUse">
            <path className="zp-hatch-line" d="M-1 1l2-2M0 7l7-7M6 8l2-2" />
          </pattern>
        </defs>
        <rect className="zp-ground" x="0" y="0" width="320" height="200" />
        {LOTS.map(([x, y, w, h, use]) => (
          <g key={`${x}-${y}`}>
            <rect className={`zp-lot zp-lot-${use}`} x={x} y={y} width={w} height={h} />
            {use === 'ind' && <rect className="zp-hatch" x={x} y={y} width={w} height={h} />}
          </g>
        ))}
        <rect className="zp-area" x="48" y="40" width="168" height="124" />
        <rect className="zp-selected" x="88" y="72" width="72" height="56" />
        <g className="zp-tag" transform="translate(56 48)">
          <rect width="58" height="18" />
          <text x="29" y="13">≤ 30 min</text>
        </g>
        <g className="zp-pin" transform="translate(106 84)">
          <rect width="36" height="22" />
          <path d="M14 22 L18 26 L22 22 Z" />
          <text x="18" y="16">78</text>
        </g>
      </svg>
      <ZoningLegend />
    </figure>
  );
}
